import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_552_6691)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 7.99979C0 3.58872 3.58881 0 8.00013 0C12.4114 0 16.0002 3.58872 16.0002 7.99979C16.0002 12.4111 12.4114 16 8.00013 16C3.58881 16 0 12.4111 0 7.99979ZM1.2845 7.99979C1.2845 11.7029 4.29708 14.7155 8.00013 14.7155C11.7031 14.7155 14.7157 11.7029 14.7157 7.99979C14.7157 4.29691 11.7031 1.28442 8.00013 1.28442C4.29708 1.28442 1.2845 4.29691 1.2845 7.99979ZM10.9595 5.98265L8.93079 8.01132L10.9595 10.04C11.2201 10.3006 11.2201 10.722 10.9595 10.9826C10.8295 11.1126 10.6588 11.178 10.4881 11.178C10.3175 11.178 10.1468 11.1126 10.0168 10.9826L7.98812 8.95398L5.95946 10.9826C5.82946 11.1126 5.65879 11.178 5.48812 11.178C5.31746 11.178 5.14679 11.1126 5.01679 10.9826C4.75612 10.722 4.75612 10.3006 5.01679 10.04L7.04546 8.01132L5.01679 5.98265C4.75612 5.72198 4.75612 5.30065 5.01679 5.03998C5.27746 4.77932 5.69879 4.77932 5.95946 5.03998L7.98812 7.06865L10.0168 5.03998C10.2775 4.77932 10.6988 4.77932 10.9595 5.03998C11.2201 5.30065 11.2201 5.72198 10.9595 5.98265Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_552_6691",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgError;
